import { tsl_contact_tsl_kontakttyp } from '../Enums/Generated/tsl_contact_tsl_kontakttyp';
import { tsl_kontaktpersonerpaansokan } from '../Enums/Generated/tsl_kontaktpersonerpaansokan';
import { PartyApplicationFullTexts } from './PartyApplicationTexts';

export enum ApplicationSteps {
  Form = 1,
  Confirmation = 2,
  ExistingBankruptcyConfirmation = 3,
}

export enum ApplicationType {
  dismissedDueToRedundancyOrContractExpiry = 1,
  companyBankruptcy = 2,
  dismissedDueToIllnessOrInjury = 3,
}

export enum ApplicantRole {
  companyRepresentative = tsl_kontaktpersonerpaansokan.Fretagsrepresentant,
  unionRepresentative = tsl_kontaktpersonerpaansokan.Fackligrepresentant,
}

export enum WorksiteAddressCountry {
  Swedish = 1,
  Foreign = 2,
}

export enum UnionRole {
  UnionRepresentative = tsl_contact_tsl_kontakttyp.FackligAnstlldombudsman,
  UnionLocalRepresentative = tsl_contact_tsl_kontakttyp.FackligLokalfackligrepresentant,
}

export enum MoreApplicationsChoice {
  Yes = 1,
  No = 2,
}

export interface PartyApplicationState {
  pageTexts: PartyApplicationFullTexts | null;
  currentStep: ApplicationSteps;
  applicationType: ApplicationType | null;
  partyRegardingApplication: string | null;
  worksiteRegardingApplication: string | null;
  applicantRole: ApplicantRole | null;
  unionRole: UnionRole | null;
}
